import { render } from "./CustomKpiList.vue?vue&type=template&id=4c4b77fa&scoped=true"
import script from "./CustomKpiList.vue?vue&type=script&lang=ts"
export * from "./CustomKpiList.vue?vue&type=script&lang=ts"

import "./CustomKpiList.vue?vue&type=style&index=0&id=4c4b77fa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4c4b77fa"

export default script